<script>
export default {
    name: "SearchResultMultiple",
    data() {
        return {
            content: null,
            isArray: null,
            imagesList: [],
            listWithAudio: []
        }
    },
    created() {
        this.$root.$on('tt-result-received', data => {
            this.content = data
            this.isArray = Array.isArray(data)
            if (this.isArray) {
                this.imagesList = data.filter(item => !item.url.some(file => file.ext === 'mp3'))
                this.listWithAudio = data.filter(item => item.url.some(file => file.ext === 'mp3'))
            }
        });
        this.$root.$on('clear-results', () => {
            this.content = null
        })
    },
    methods: {
        bytesToMB(bytes) {
          return (bytes / (1024 * 1024)).toFixed(2);
        }
    },
}
</script>

<template>
  <section class="multiple container" v-if="content && isArray">
    <h3 class="multiple__title">Search Result</h3>
    <div class="multiple__content">
      <div class="multiple__content-cards">
        <div class="multiple__content-item" v-for="image in imagesList" :key="image.id">
          <img
            :src="image.thumb"
            alt=""
            class="multiple__content-image"
          />
          <a :href="image.url[0].url" class="multiple__content-download">
            <img
              src="/img/searchMultiple/download.svg"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="multiple__content-info desktop">
        <p class="multiple__content-author">@{{ content[0].meta.author.nickname ?? content[0].meta.author.unique_id }}</p>
        <p class="multiple__content-text">
          {{ content[0].meta.title }}
        </p>
      </div>
    </div>
    <div class="multiple__table" v-if="listWithAudio.length">
      <div class="multiple__table-head">
        <div class="multiple__table-column">Quality</div>
        <div class="multiple__table-column">Download</div>
      </div>
      <div class="multiple__table-content" v-for="item of listWithAudio" :key="item.id">
        <div class="multiple__table-item" v-for="itemUrl of item.url" :key="itemUrl.url">
          <div class="multiple__table-cell">{{ itemUrl.ext }}</div>
          <div class="multiple__table-cell">
            <a :href="itemUrl.url" class="multiple__table-btn">Download Audio</a>
          </div>
        </div>
      </div>
    </div>
    <div class="multiple__content-info mobile">
        <p class="multiple__content-author">@{{ content[0].meta.author.nickname }}</p>
        <p class="multiple__content-text">
          {{ content[0].meta.title }}
        </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.container {
  max-width: 1200px;
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
}

.multiple {
  max-width: 1170px;
  width: 100%;
  padding: 0 20px 100px;
  overflow-y: hidden;

  &__title {
    text-align: center;

    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    color: var(--primary-color);
  }

  &__content {
    margin: 40px 0;

    &-info {
      &.mobile {
        display: none;
      }

      @media screen and (max-width: 768px) {
        &.desktop {
          display: none;
        }

        &.mobile {
          display: block;
        }
      }
    }

    &-cards {
      display: flex;
      justify-content: center;
      gap: 24px;
      flex-wrap: wrap;
      max-width: 1200px;
      margin: 0 auto;

      @media (max-width: 1127px) {
        justify-content: center;
      }

      @media (max-width: 992px) {
        justify-content: center;
      }

      @media (max-width: 768px) {
        gap: 16px;
      }
    }

    &-item {
      width: 350px;
      height: 510px;
      position: relative;
      display: inline-block;
      max-width: 100%;
      box-sizing: border-box;

      @media (max-width: 420px) {
        max-width: 350px;
        width: 100%;
        min-height: 510px !important;
        height: auto;
        margin: 0 auto;
      }
    }

    &-image {
      width: 100%;
      height: 510px !important;
      overflow: hidden;
      object-fit: cover;
      border-radius: 6px;

      @media (max-width: 420px) {
        height: auto;
      }
    }

    &-download {
      position: absolute;
      right: 12px;
      top: 12px;
      cursor: pointer;

      & img {
        width: 100%;
        max-width: 364px;
        height: auto;
      }
    }

    &-author {
      font-family: "Roboto", sans-serif;
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      color: var(--second-color);
      margin-bottom: 12px;
    }

    &-text {
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 30px;
      opacity: 0.8;
      color: var(--second-color);
      width: 100%;
    }
  }

  &__table {
    max-width: 600px;
    border: 1px solid #443582;
    border-radius: 10px;
    overflow: hidden;
    &-head {
      border-bottom: 1px solid #443582;
    }
    &-head,
    &-item {
      display: grid;
      grid-template-columns: 1fr 1fr ;
      @media all and (max-width: 450px) {
        grid-template-columns: 1fr 1fr;
      }
    }

    &-column {
      width: 100%;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      line-height: 1.25;
      color: var(--second-color);
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      background-color: #121212;
      &:first-child {
        border-right: 1px solid #443582;
      }
      &:nth-child(odd) {
        border-right: 1px solid #443582;
      }
    }



    &-cell {
      width: 100%;
      height: 80px;
      padding: 20px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: "Roboto", sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 1.25;
      color: var(--primary-color);

      &:first-child {
        border-right: 1px solid #443582;
      }
      &:nth-child(odd) {
        border-right: 1px solid #443582;
      }

      @media (max-width: 576px) {
        font-size: 16px;
      }
    }

    &-btn {
      background: linear-gradient(360deg, #E92F00 9.5%, #FF6A00 111.29%);
      outline: none;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.25;
      color: #fff;
      padding: 12px 52px;
      width: 100%;
      text-decoration: none;
      text-align: center;
      transition: all .3s ease;
      &:hover {
        background: linear-gradient(360deg, #F60C00 9.5%, #FF8731 111.29%), linear-gradient(360deg, #F61D00 9.5%, #FF5E00 111.29%);
      }

      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
  }
}
</style>
